/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ selected: NonNullable<unknown>, primary: NonNullable<unknown> }} Speaker_Manager_Merge_TextInputs */

const en_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to merge ${i?.selected} with ${i?.primary}? ${i?.primary} will be the primary speaker and ${i?.selected} will be removed.`)
};

const fr_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment fusionner ${i?.selected} avec ${i?.primary} ? ${i?.primary} sera le locuteur principal et ${i?.selected} sera supprime.`)
};

const de_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sind Sie sicher, dass Sie ${i?.selected} mit ${i?.primary} zusammenführen möchten? ${i?.primary} wird der Hauptsprecher sein und ${i?.selected} wird entfernt.`)
};

const it_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuoi davvero unire ${i?.selected} con ${i?.primary}? ${i?.primary} sarà l'oratore principale e ${i?.selected} verrà rimosso.`)
};

const ru_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите объединить ${i?.selected} с ${i?.primary}? ${i?.primary} будет основным говорящим, а ${i?.selected} будет удален.`)
};

const es_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea fusionar ${i?.selected} con ${i?.primary}? ${i?.primary} será el hablante principal y ${i?.selected} se eliminará.`)
};

const zh_cn2_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要将 ${i?.selected} 与 ${i?.primary} 合并吗？合并后，${i?.primary} 将成为主要发言人，而 ${i?.selected} 将被移除。`)
};

const ja_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} を ${i?.primary} と結合してもよろしいですか? ${i?.primary} がメインスピーカーになり、${i?.selected} は削除されます。`)
};

const hi_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई ${i?.selected} को ${i?.primary} के साथ मर्ज करना चाहते हैं? ${i?.primary} मुख्य वक्ता होगा और ${i?.selected} को हटा दिया जाएगा।`)
};

const pt_pt2_speaker_manager_merge_text = /** @type {(inputs: Speaker_Manager_Merge_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja mesclar ${i?.selected} com ${i?.primary}? ${i?.primary} será o alto-falante principal e ${i?.selected} será removido.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to merge {selected} with {primary}? {primary} will be the primary speaker and {selected} will be removed." |
*
* @param {Speaker_Manager_Merge_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_text = /** @type {((inputs: Speaker_Manager_Merge_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_merge_text(inputs)
	if (locale === "de") return de_speaker_manager_merge_text(inputs)
	if (locale === "it") return it_speaker_manager_merge_text(inputs)
	if (locale === "ru") return ru_speaker_manager_merge_text(inputs)
	if (locale === "es") return es_speaker_manager_merge_text(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_merge_text(inputs)
	if (locale === "ja") return ja_speaker_manager_merge_text(inputs)
	if (locale === "hi") return hi_speaker_manager_merge_text(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_merge_text(inputs)
	return en_speaker_manager_merge_text(inputs)
});